(function () {
  if (window.__tinyImgPreloaderLoaded) return;
  window.__tinyImgPreloaderLoaded = true;

  let urlToPreload, mouseoverTimer, lastTouchTimestamp;
  const prefetcher = document.createElement("link");
  const isSupported = prefetcher.relList && prefetcher.relList.supports && prefetcher.relList.supports("prefetch");
  const isDataSaverEnabled = navigator.connection && navigator.connection.saveData;
  const allowQueryString = "instantAllowQueryString" in document.body.dataset;
  const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;

  if (isSupported && !isDataSaverEnabled) {
    prefetcher.rel = "prefetch";
    document.head.appendChild(prefetcher);
    const opts = { capture: true, passive: true };
    document.addEventListener("touchstart", touchstartListener, opts);
    document.addEventListener("mouseover", mouseoverListener, opts);
  }

  function touchstartListener(e) {
    lastTouchTimestamp = performance.now();
    const a = e.target.closest("a");
    if (isPreloadable(a)) {
      a.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: true });
      a.addEventListener("touchend", touchendAndTouchcancelListener, { passive: true });
      urlToPreload = a.href;
      preload(a.href);
    }
  }
  function touchendAndTouchcancelListener() { urlToPreload = undefined; stopPreloading(); }
  function mouseoverListener(e) {
    if (performance.now() - lastTouchTimestamp < 1100) return;
    const a = e.target.closest("a");
    if (isPreloadable(a)) {
      a.addEventListener("mouseout", mouseoutListener, { passive: true });
      urlToPreload = a.href;
      mouseoverTimer = setTimeout(function () { preload(a.href); mouseoverTimer = undefined; }, 65);
    }
  }
  function mouseoutListener(e) {
    const same = e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a");
    if (same) return;
    if (mouseoverTimer) { clearTimeout(mouseoverTimer); mouseoverTimer = undefined; }
    else { urlToPreload = undefined; stopPreloading(); }
  }
  function isPreloadable(a) {
    if (!a || !a.href) return false;
    if (urlToPreload == a.href) return false;
    const t = new URL(a.href);
    if (!["http:", "https:"].includes(t.protocol)) return false;
    if (t.protocol === "http:" && location.protocol === "https:") return false;
    const allowLink = allowExternalLinks || t.origin === location.origin || "instant" in a.dataset;
    if (!allowLink) return false;
    const allowQS = allowQueryString || !t.search || "instant" in a.dataset;
    if (!allowQS) return false;
    const sameDoc = t.hash && t.pathname + t.search === location.pathname + location.search;
    if (sameDoc) return false;
    if ("noInstant" in a.dataset) return false;
    return true;
  }
  function preload(href) { prefetcher.href = href; }
  function stopPreloading() { prefetcher.removeAttribute("href"); }
})();
